import { CloseIcon } from '@chakra-ui/icons';
import { Button, Stack, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { routes } from '@blockpulse3/data/shared';

import { useUser } from '../../providers';

type Props = unknown;

export function VerifyEmailFailure(): JSX.Element {
  const i18nVerifyEmailForm = useTranslations('VerifyEmailForm');
  const { status } = useUser();

  return (
    <Stack align="center" direction="column" spacing="8">
      <Stack alignSelf="center" direction="row" gap="4">
        <CloseIcon color="red.400" h="8" w="8" />
        <Text fontSize="xl" fontWeight="bold">
          {i18nVerifyEmailForm('EmailVerificationFailure')}
        </Text>
      </Stack>
      <Link
        style={{ width: '100%' }}
        to={status === 'authenticated' ? routes.home.href : routes.login.href}
      >
        <Button width="full">{i18nVerifyEmailForm('RedirectHome')}</Button>
      </Link>
    </Stack>
  );
}

export type VerifyEmaiFailureProps = Props;
